import type { Editor } from "@tiptap/react";
import { useEffect, useState } from "react";

export function useEditorCustomState(editor: Editor | null) {
  const [openLinkDialog, setOpenLinkDialog] = useState(false);
  const [openBubbleLink, setOpenBubbleLink] = useState(false);
  const [existingLink, setExistingLink] = useState("");

  useEffect(() => {
    if (!editor) return;

    // Set up the callback for custom state changes
    const stateChangeHandler = () => {
      setOpenLinkDialog(editor.storage.customState?.openLinkDialog ?? false);
      setOpenBubbleLink(editor.storage.customState?.openBubbleLink ?? false);
      setExistingLink(editor.getAttributes("link").href ?? "");
    };

    // Register callback with extension
    if (editor.storage.customState) {
      editor.storage.customState.onStateChange = stateChangeHandler;
    }

    // Initial state sync
    stateChangeHandler();

    // Also listen to transaction for link attribute changes
    editor.on("transaction", stateChangeHandler);

    return () => {
      editor.off("transaction", stateChangeHandler);
      if (editor.storage.customState) {
        editor.storage.customState.onStateChange = undefined;
      }
    };
  }, [editor]);

  return { openLinkDialog, openBubbleLink, existingLink };
}
